import { CrudList } from '../shared/CrudPage';
import { attendanceService, enumLabel } from '@kss/api';
import type { Attendance, AttendanceCreate, AttendanceFilter } from '@kss/api';
import { StatusBadge } from '@kss/ui';
import { NameCell } from '../../hooks/useNameMaps';

export default function AllAttendances() {
  return (
    <CrudList<Attendance, AttendanceCreate, AttendanceFilter>
      title="All attendance" newLabel="New entry" service={attendanceService}
      idKey="attendanceId" labelKey="attendanceDate" basePath="/panel/attendance"
      // Newest attendance row on top — chronological. Ref: ORDER_WORKFLOW_AUDIT #6.
      initialSortStatus={{ columnAccessor: 'attendanceDate', direction: 'desc' }}
      columns={[
        { accessor: 'attendanceDate', title: 'Date', sortable: true,
          render: (r) => (r.attendanceDate ?? r.date) ? new Date((r.attendanceDate ?? r.date)!).toLocaleDateString() : '—' },
        { accessor: 'employeeId', title: 'Employee', render: (r) => <NameCell kind="employee" id={r.employeeId} /> },
        { accessor: 'checkIn', title: 'Check-in', render: (r) => r.checkIn ?? r.checkInTime ?? '—' },
        { accessor: 'checkOut', title: 'Check-out', render: (r) => r.checkOut ?? r.checkOutTime ?? '—' },
        { accessor: 'workHours', title: 'Hours', sortable: true, textAlign: 'right', render: (r) => r.workHours != null ? Number(r.workHours).toFixed(2) : '—' },
        { accessor: 'status', title: 'Status', sortable: true,
          render: (r) => <StatusBadge status={enumLabel('AttendanceStatus', typeof r.status === 'number' ? r.status : Number(r.status))} /> },
      ]}
    />
  );
}
